// Базовый URL API
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

// Основной префикс API
const API_PREFIX = '';

// Версии API (исправлено по вашему требованию)
export const API_VERSIONS = {
  v1: 'v1',
  v2: 'v2',
};

// Конфигурация API (добавлено)
export const API_CONFIG = {
  baseURL: API_BASE_URL,
  prefix: API_PREFIX,
  versions: API_VERSIONS
};

// Функция для создания полного пути (универсальная)
const createApiPath = (versionKey: keyof typeof API_VERSIONS, path: string) => {
  const version = API_VERSIONS[versionKey];

  // Для режима с проксированием (production)
  if (!API_CONFIG.baseURL) {
    return `${API_CONFIG.prefix}/${version}/${path}`;
  }

  // Для локальной разработки (без прокси)
  return `${API_CONFIG.baseURL}${API_CONFIG.prefix}/${version}/${path}`;
};
// Группы API
export const API_ROUTES = {
  // Справочные данные (v1)
  reference: {
    currencies: createApiPath('v1', 'common/currencies'),
    currenciesSelect: createApiPath('v1', 'common/currencies'),
    cities: createApiPath('v1', 'common/cities'),
    countries: createApiPath('v1', 'common/countries'),
    countriesSelect: createApiPath('v1', 'common/countries'),
    counterparties: createApiPath('v1', 'common/counterparties'),
    // Почта контрагента для доступа: своё право (admin, useradmin), поэтому
    // и свой адрес, а не поле в карточке.
    counterpartyAccessEmails: (id: number | string) =>
      `${createApiPath('v1', 'common/counterparties')}/${id}/access-emails`,
    counterpartiesSelect: createApiPath('v1', 'common/counterparties'),
    counterpartyClients: createApiPath('v1', 'common/counterparty-clients'),
    counterpartyClientTypes: createApiPath('v1', 'common/counterparty-client-types'),
    counterpartyCoefficientTypes: createApiPath('v1', 'common/counterparty-coefficient-types'),
    securityKinds: createApiPath('v1', 'common/security-kinds'),
    securityForms: createApiPath('v1', 'common/security-forms'),
    securityTypes: createApiPath('v1', 'common/security-types'),
    accounts: createApiPath('v1', 'accounts'),
    accountsSelect: createApiPath('v1', 'common/accounts'),
    licenses: createApiPath('v1', 'common/licenses'),
    licenseTypes: createApiPath('v1', 'common/license-types'),
    securities: createApiPath('v1', 'common/securities'),
    securitiesSelect: createApiPath('v1', 'common/securities'),
    chartOfAccounts: createApiPath('v1', 'common/chart-of-accounts'),
    services: createApiPath('v1', 'common/services'),
    tariffs: createApiPath('v1', 'common/tariffs'),
    taxRates: createApiPath('v1', 'common/tax-rates'),
    accruals: createApiPath('v1', 'common/accruals'),
    thirdPartyInvoices: createApiPath('v1', 'common/third-party-invoices'),
    accrualExports: createApiPath('v1', 'common/accrual-exports'),
    banks: createApiPath('v1', 'common/banks'),
  },
  // Документы (v1) - ИЗМЕНЕНИЯ ЗДЕСЬ
  documents: {
    categories: createApiPath('v1', 'documents/document-categories'),
    types: createApiPath('v1', 'documents/document-types'),
    // 🔹 ОСНОВНОЙ ПУТЬ ДЛЯ ДОКУМЕНТОВ
    base: createApiPath('v1', 'documents'), // ✅ Новый путь для документов
    // 🔹 ПУТИ ДЛЯ КОНКРЕТНЫХ ДОКУМЕНТОВ
    byId: (id: number) => `${createApiPath('v1', 'documents')}/${id}`,
    // 🔹 ПУТИ ДЛЯ ЗАЯВОК КОНКРЕТНОГО ДОКУМЕНТА
    orders: (documentId: number) => `${createApiPath('v1', 'documents')}/${documentId}/orders`,
    statusTypes: createApiPath('v1', 'documents/document-status-types'),
    statusTransitions: createApiPath('v1', 'documents/status-transitions'),
    limitsToTs:  createApiPath('v1', 'documents/limits-to-ts'),
    trades:      createApiPath('v1', 'documents/trades'),
    incomeRequisites: createApiPath('v1', 'documents/income-requisites'),
    incomeRequisite: (id: number) => `${createApiPath('v1', 'documents/income-requisites')}/${id}`,
    cashWithdrawals: createApiPath('v1', 'documents/cash-withdrawals'),
    cashWithdrawal: (documentId: number) => `${createApiPath('v1', 'documents/cash-withdrawals')}/${documentId}`,
    cashWithdrawalSelectBank: (documentId: number) => `${createApiPath('v1', 'documents/cash-withdrawals')}/${documentId}/select-bank`,
    cashWithdrawalBanks: createApiPath('v1', 'documents/cash-withdrawals/banks'),
    cashWithdrawalRequisites: createApiPath('v1', 'documents/cash-withdrawals/requisites'),
    // Доход по ЦБ (купон, погашение, дивиденды). Центр процесса — строка
    // графика выплат: по ней заводятся поступление и начисление, и по ней же
    // считается статус выплаты. Выплата депоненту — отдельный документ этапа 3.
    incomeSchedule: createApiPath('v1', 'documents/income-schedule'),
    incomeScheduleRow: (scheduleId: number) =>
      `${createApiPath('v1', 'documents/income-schedule')}/${scheduleId}`,
    incomeScheduleCancel: (scheduleId: number) =>
      `${createApiPath('v1', 'documents/income-schedule')}/${scheduleId}/cancel`,
    incomeScheduleStates: createApiPath('v1', 'documents/income-schedule/states'),
    incomeMonitorIssues: createApiPath('v1', 'documents/income-schedule/monitor/issues'),
    incomeMonitorSummary: createApiPath('v1', 'documents/income-schedule/monitor/summary'),
    incomeMonitorQueue: createApiPath('v1', 'documents/income-schedule/monitor/queue'),
    incomeMonitorStats: createApiPath('v1', 'documents/income-schedule/monitor/stats'),
    incomeReceipts: createApiPath('v1', 'documents/income-receipts'),
    incomeReceipt: (documentId: number) =>
      `${createApiPath('v1', 'documents/income-receipts')}/${documentId}`,
    incomeReceiptBanks: createApiPath('v1', 'documents/income-receipts/banks'),
    incomeReceiptReconcile: (scheduleId: number) =>
      `${createApiPath('v1', 'documents/income-receipts')}/reconcile/${scheduleId}`,
    incomeAccruals: createApiPath('v1', 'documents/income-accruals'),
    incomeAccrual: (documentId: number) =>
      `${createApiPath('v1', 'documents/income-accruals')}/${documentId}`,
    incomeAccrualCalculate: (documentId: number) =>
      `${createApiPath('v1', 'documents/income-accruals')}/${documentId}/calculate`,
    incomeAccrualLineAmount: (documentId: number, lineId: number) =>
      `${createApiPath('v1', 'documents/income-accruals')}/${documentId}/lines/${lineId}/amount`,
    incomeAccrualDiscrepancy: (documentId: number) =>
      `${createApiPath('v1', 'documents/income-accruals')}/${documentId}/discrepancy`,
    incomePayouts: createApiPath('v1', 'documents/income-payouts'),
    incomePayout: (documentId: number) =>
      `${createApiPath('v1', 'documents/income-payouts')}/${documentId}`,
    incomePayoutsFromAccrual: (accrualDocumentId: number) =>
      `${createApiPath('v1', 'documents/income-payouts')}/from-accrual/${accrualDocumentId}`,
    incomePayoutGate: (scheduleId: number) =>
      `${createApiPath('v1', 'documents/income-payouts')}/gate/${scheduleId}`,
    incomePayoutRequisites: (depositorId: number) =>
      `${createApiPath('v1', 'documents/income-payouts')}/requisites/${depositorId}`,
    incomePayoutFee: (documentId: number) =>
      `${createApiPath('v1', 'documents/income-payouts')}/${documentId}/fee`,
    incomePayoutHolds: createApiPath('v1', 'documents/income-payout-holds'),
    incomePayoutHoldRelease: (holdId: number) =>
      `${createApiPath('v1', 'documents/income-payout-holds')}/${holdId}/release`,

  },
  deponent:{
    myBalances: createApiPath('v1', 'deponent/my/balances'),
    balance: createApiPath('v1', 'deponent/balance'),
  },
  // Аутентификация (v1)
  auth: {
    login: createApiPath('v1', 'auth/login'),
    logout: createApiPath('v1', 'auth/logout'),
    me: createApiPath('v1', 'users/me'),
    roles: createApiPath('v1', 'auth/roles'),
    esiaLogin: createApiPath('v1', 'auth/esia/login'),
    esiaExchange: createApiPath('v1', 'auth/esia/exchange'),
    ecpChallenge: createApiPath('v1', 'auth/ecp/challenge'),
    ecpVerify: createApiPath('v1', 'auth/ecp/verify'),
    registerEcpVerify: createApiPath('v1', 'auth/register/ecp/verify'),
    registerSubmit: createApiPath('v1', 'auth/register/submit'),
    registerActivate: createApiPath('v1', 'auth/register/activate'),
    // Пароль: состояние политики и смена (docs/tasks/auth-password-ip-policy.md)
    passwordState: createApiPath('v1', 'auth/password/state'),
    passwordChange: createApiPath('v1', 'auth/password/change'),
    // Забытый пароль: запрос ссылки и смена по ней. Публичные — человек не вошёл
    passwordRequirements: createApiPath('v1', 'auth/password/requirements'),
    forgotPassword: createApiPath('v1', 'auth/forgot-password'),
    resetPassword: createApiPath('v1', 'auth/reset-password'),
    // Решение контрагента по заявке: confirm | reject | block. Публичные —
    // у контрагента учётной записи в системе нет, только ссылка из письма.
    registerOwnerAction: (action: 'confirm' | 'reject' | 'block') =>
      `${createApiPath('v1', 'auth/register/owner')}/${action}`,
    memberships: createApiPath('v1', 'auth/memberships'),
    context: createApiPath('v1', 'auth/context'),
  },
  // Отчеты (v1)
  reports: {
    // Локальный рендер отчётов и печатных форм (замена JasperServer)
    localPrint: (code: string) => `${createApiPath('v1', 'reports/local')}/${code}/print`,
    localDocPrint: (code: string) => `${createApiPath('v1', 'reports/local/doc')}/${code}/print`,
    // Список печатных форм по типу документа
    documentForms: (documentTypeId: number) => `${createApiPath('v1', 'reports/documents')}/${documentTypeId}/forms`,
  },
  // Администрирование (v1)
  admin: {
    reports: createApiPath('v1', 'admin/reports'),
    externalApi: createApiPath('v1', 'admin/external'),
    users: createApiPath('v1', 'admin/users'),
    userApprove: (id: number) => `${createApiPath('v1', 'admin/users')}/${id}/approve`,
    userResendActivation: (id: number) =>
      `${createApiPath('v1', 'admin/users')}/${id}/resend-activation`,
    userDeactivate: (id: number) => `${createApiPath('v1', 'admin/users')}/${id}/deactivate`,
  },
  // Журнал действий (v1) — только чтение, эндпоинтов записи нет
  audit: {
    events: createApiPath('v1', 'audit/events'),
    event: (id: number) => `${createApiPath('v1', 'audit/events')}/${id}`,
    export: createApiPath('v1', 'audit/events/export'),
    dictionaries: createApiPath('v1', 'audit/dictionaries'),
    // История по одной записи справочника: открыта тем, кто его ведёт
    history: (entityType: string, entityId: number | string) =>
      `${createApiPath('v1', 'audit/history')}/${entityType}/${entityId}`,
  },
  // Сообщения (v1)
  messages: {
    base: createApiPath('v1', 'messages'),
    sent: createApiPath('v1', 'messages/sent'),
    unreadCount: createApiPath('v1', 'messages/unread-count'),
    readAll: createApiPath('v1', 'messages/read-all'),
    read: (id: number) => `${createApiPath('v1', 'messages')}/${id}/read`,
    archive: (id: number) => `${createApiPath('v1', 'messages')}/${id}/archive`,
  },
  // Системная информация (v1) — окружение для бейджа ТЕСТ/ПРОД
  system: {
    config: createApiPath('v1', 'config'),
  },
  // Торговый день (v1)
  tradingDay: {
    current: createApiPath('v1', 'trading-day/current'),
    open: createApiPath('v1', 'trading-day/open'),
    close: createApiPath('v1', 'trading-day/close'),
    limitsReconcile: createApiPath('v1', 'trading-day/limits-reconcile'),
    // Справочники ТС (контрагенты, инструменты, валюты): счётчики и записи не в SYNCED
    referencesSummary: createApiPath('v1', 'trading-day/references-summary'),
    referenceItems: (kind: string) => `${createApiPath('v1', 'trading-day/references')}/${kind}/items`,
  },
  // Депоненты нулевых лимитов T+ (справочник quik)
  tplusZeroLimitDeponents: {
    base: createApiPath('v1', 'quik/tplus-zero-limit-deponents'),
    item: (id: number) => `${createApiPath('v1', 'quik/tplus-zero-limit-deponents')}/${id}`,
  },
  // Торговая система (только показ)
  tradingSystem: {
    orders: createApiPath('v1', 'trading-system/orders'),
  },
  // Фоновые задачи: расписания и журнал запусков (v1)
  jobs: {
    schedulerStatus: createApiPath('v1', 'jobs/scheduler-status'),
    schedules: createApiPath('v1', 'jobs/schedules'),
    schedule: (jobName: string) => `${createApiPath('v1', 'jobs/schedules')}/${jobName}`,
    run: (jobName: string) => `${createApiPath('v1', 'jobs/schedules')}/${jobName}/run`,
    runs: createApiPath('v1', 'jobs/runs'),
  },
  // Календари (v1)
  calendar: {
    calendars: createApiPath('v1', 'common/calendars'),
    calendarsSelect: createApiPath('v1', 'common/calendars/select/options'),
    rules: createApiPath('v1', 'common/calendar-rules'),
    exceptions: createApiPath('v1', 'common/calendar-exceptions'),
    tradingSessions: createApiPath('v1', 'common/trading-sessions'),
  },

};

// Для обратной совместимости
export const LEGACY_API_ROUTES = {
  currencies: API_ROUTES.reference.currencies,
  cities: API_ROUTES.reference.cities,
  countries: API_ROUTES.reference.countries,
  // ... остальные
};

export const LEGACY_API_AUTH_ROUTES = {
  login: API_ROUTES.auth.login,
  logout: API_ROUTES.auth.logout,
  me: API_ROUTES.auth.me,
};
